const getInitialState = (props) => {
  const { purchaseType, defaultDeliveryInterval } = props;
  return {
    configurations: {
      purchaseType,
      subscriptionPurchaseConfigurations: {
        deliveryInterval: defaultDeliveryInterval ?? null
      },
      quantity: 1
    },
    configurator: {
      invalidSubmissionsCount: void 0,
      deliveryInterval: {
        showError: false
      }
    }
  };
};
export {
  getInitialState
};
//# sourceMappingURL=get-initial-state.js.map
